import React from 'react'
import PropTypes from 'prop-types'
import { useDrag } from 'react-dnd'
import { Box } from '@mui/material_modern'

const CustomCheckTemplateItem = ({ id, textAlignment, x, top, children }) => {
  const [{ isDragging }, drag] = useDrag(
    () => ({
      type: 'field',
      item: { id, textAlignment, x, top },
      collect: monitor => ({
        isDragging: monitor.isDragging(),
      }),
    }),
    [id, textAlignment, x, top],
  )
  if (isDragging) {
    return <Box ref={drag} />
  }
  return (
    <Box
      ref={drag}
      sx={{
        position: 'absolute',
        border: '1px dashed gray',
        backgroundColor: 'background.item',
        paddingLeft: 4,
        paddingRight: 4,
        cursor: 'move',
        ...(id === 'customerAddress' && { paddingTop: '1em', paddingBottom: '1em' }),
        ...(id === 'checkSignature' && { paddingTop: '1em', paddingBottom: '1em' }),
        ...(textAlignment === 'left' && { left: x }),
        ...(textAlignment === 'right' && { right: x }),
        top,
      }}
      data-testid="field"
    >
      {children}
    </Box>
  )
}

CustomCheckTemplateItem.propTypes = {
  id: PropTypes.string.isRequired,
  textAlignment: PropTypes.string,
  x: PropTypes.number,
  top: PropTypes.number,
  children: PropTypes.node.isRequired,
}

CustomCheckTemplateItem.defaultProps = {
  textAlignment: 'left',
  x: 0,
  top: 0,
}

export default CustomCheckTemplateItem
